import { render, staticRenderFns } from "./BookNow.vue?vue&type=template&id=5d180ae7&"
import script from "./BookNow.vue?vue&type=script&lang=js&"
export * from "./BookNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports